import { createLocalStorageStore } from 'features/entryBrowser/hooks/createLocalStorageStore'

export interface FavoriteSearch {
  query: string
  contentFilter: string
  timestamp: number
}

const MAX_FAVORITE_SEARCHES = 50
const STORAGE_KEY_PREFIX = 'gecko_favorite_searches:v1'

function getStorageKey(userId: string, siteId: string): string {
  return `${STORAGE_KEY_PREFIX}_${userId}_${siteId}`
}

const storeCache = new Map<
  string,
  ReturnType<typeof createLocalStorageStore<FavoriteSearch>>
>()

export function getFavoriteSearchesStore(userId: string, siteId: string) {
  const key = getStorageKey(userId, siteId)
  let store = storeCache.get(key)
  if (!store) {
    store = createLocalStorageStore<FavoriteSearch>(key, MAX_FAVORITE_SEARCHES)
    storeCache.set(key, store)
  }
  return store
}
